export type StorageAdapter = {
  getAccessToken(): Promise<string | null> | string | null;
  getRefreshToken(): Promise<string | null> | string | null;
  setAccessToken(token: string): Promise<void> | void;
  setRefreshToken(token: string): Promise<void> | void;
  clear(): Promise<void> | void;
};

export type PlatformAdapter = {
  redirectToLogin?(): void | Promise<void>;
  restartApp?(): void | Promise<void>;
  onLogout?(): void | Promise<void>;
};

export type ApiConfig = {
  baseURL: string;
  storage: StorageAdapter;
  platform?: PlatformAdapter;
  publicPaths?: string[];
  timeoutMs?: number;
};

const DEFAULT_PUBLIC_PATHS = [
  "/accounts/login/",
  "/accounts/register/",
  "/accounts/reset-password-confirm/",
  "/accounts/reset-password/",
  "/accounts/token/refresh/",
];

let apiConfig: ApiConfig | undefined;

export const initApi = (config: ApiConfig) => {
  apiConfig = config;
};

export const ensureConfig = (): ApiConfig => {
  if (!apiConfig) {
    throw new Error("API not initialized. Call initApi(...) before using API helpers.");
  }
  return apiConfig;
};

export const getPublicPaths = (): string[] => ensureConfig().publicPaths ?? DEFAULT_PUBLIC_PATHS;

export const makeStorageAdapter = (adapter: StorageAdapter): StorageAdapter => adapter;
export const makePlatformAdapter = (adapter: PlatformAdapter = {}): PlatformAdapter => adapter;
